import { render, staticRenderFns } from "./IDardlist.vue?vue&type=template&id=28a9ca0f&"
import script from "./IDardlist.vue?vue&type=script&lang=js&"
export * from "./IDardlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports